/**
 * ProviderSettingsPage — `/dashboard/provider/settings`.
 *
 * Phase 2 dispatch #3: settings hosts the MembershipSection (tier
 * subscription panel) — the only setting currently exposed inside
 * the provider workspace. Future settings (notifications, payouts
 * details, danger-zone) land here too.
 */
import React from "react";
import MembershipSection from "@/components/dashboard/MembershipSection";
import { useAuth } from "@/context/AuthContext";

export default function ProviderSettingsPage() {
  const { providerProfile } = useAuth();

  return (
    <div className="mx-auto max-w-6xl" data-testid="provider-settings-page">
      <header className="mb-6">
        <span className="text-sm font-bold uppercase tracking-wider text-brand-orange">
          Settings
        </span>
        <h2 className="font-heading text-3xl font-bold text-pp-text">
          Workspace settings
        </h2>
        <p className="mt-1 text-sm text-muted-foreground">
          Manage your PooPartner membership tier and other workspace settings.
        </p>
      </header>

      <MembershipSection providerProfile={providerProfile} />
    </div>
  );
}
